<div class="modal-backdrop" (click)="onBackdropClick($event)">
  <div class="modal-container">
    <div class="modal-header">
      <h2 class="modal-title">Email Preview</h2>
      <button class="close-btn" (click)="onCloseClick()">
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 3L3 9M3 3L9 9" stroke="#555963" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
    </div>
    
    <div class="modal-content">
      <div class="email-header">
        <div class="email-info">
          <h3 class="email-subject">Subject: {{ currentEmailData.subject }}</h3>
          <p class="email-from">From: {{ currentEmailData.fromEmail }}</p>
        </div>
        
        <div class="view-tabs">
          <button class="tab" [class.active]="activeTab === 'desktop'" (click)="switchTab('desktop')">
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.25 3H15.75C16.1642 3 16.5 3.33579 16.5 3.75V14.25C16.5 14.6642 16.1642 15 15.75 15H2.25C1.83579 15 1.5 14.6642 1.5 14.25V3.75C1.5 3.33579 1.83579 3 2.25 3Z" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M1.5 6H16.5" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <button class="tab" [class.active]="activeTab === 'mobile'" (click)="switchTab('mobile')">
            <svg width="12" height="16" viewBox="0 0 12 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.25 2H6.75M6 11.75V11.7575M1.5 2.75C1.5 2.35218 1.65804 1.97064 1.93934 1.68934C2.22064 1.40804 2.60218 1.25 3 1.25H9C9.39782 1.25 9.77936 1.40804 10.0607 1.68934C10.342 1.97064 10.5 2.35218 10.5 2.75V13.25C10.5 13.6478 10.342 14.0294 10.0607 14.3107C9.77936 14.592 9.39782 14.75 9 14.75H3C2.60218 14.75 2.22064 14.592 1.93934 14.3107C1.65804 14.0294 1.5 13.6478 1.5 13.25V2.75Z" stroke="#15172E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
      
      <div class="email-preview-container" [class.mobilepreview]="activeTab === 'mobile'">
        <app-email-preview
        [emailData]="currentEmailData"
        (viewInBrowser)="onViewInBrowser()">
      </app-email-preview>
      </div>
    </div>
  </div>
</div>
